<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
  >
    <van-form style="position: relative; margin-top: 1rem; display: flex">
      <van-field v-model="formData.name" name="name" label="类目名称" />
      <van-button type="primary" @click="search">查询</van-button>
    </van-form>
    <div class="tableBox">
      <CustomTable
        ref="table"
        :maxHeight="maxHeight"
        :scrollWidth="200"
        :columns="columns"
        :tableData="tableData"
        :showPagination="false"
        @selectedRowChange="showActive"
        :total="totalCount"
        :pageIndex="pageIndex"
        :pageSize="pageSize"
        @pageChange="pageChange"
      ></CustomTable>
    </div>
  </van-dialog>
</template>
<script>
import { AVAILABLE } from "../utils/constants";
import { reqCategory } from "../service/api/product";
import CustomTable from "./customTable.vue";

// 导入样式
export default {
  name: "categorySelect",
  components: {},
  props: {
    visible: false,
    requestParams: Object,
  },
  components: { CustomTable },
  data() {
    return {
      tableData: [],
      columns: [
        {
          field: "radio",
          key: "b",
          // type=radio
          type: "radio",
          title: "单选",
          width: 20,
          align: "left",
        },
        { field: "code", key: "code", title: "编号", width: 50 },
        { field: "name", key: "name", title: "名称", width: 50 },
      ],
      maxHeight: 400,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      totalPage: 1,
      show: false,
      data: [],
      formData: { name: "", available: true },
      statusList: AVAILABLE,
      categoryList: [],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.getProductList();
      this.show = newVal;
      this.$nextTick(() => {
        this.$refs.table && this.$refs.table.unselectedAll();
      });
    },
  },
  created() {
    this.maxHeight = window.innerHeight * 0.75 - 200;
    window.addEventListener("resize", () => {
      this.maxHeight = window.innerHeight * 0.75 - 200;
    });
  },
  methods: {
    search() {
      const ids = this.data.reduce((pre, cur) => {
        if (cur.name.includes(this.formData.name)) {
          pre.push(cur.id);
          if (cur.parentId) {
            pre.push(cur.parentId);
          }
        }
        return pre;
      }, []);
      if (ids.length == 0) {
        this.tableData = [];
      } else
        this.tableData = this.data.filter((el) => {
          return ids.findIndex((i) => i === el.id) !== -1;
        });
    },
    showActive(item) {
      this.currentRow = item;
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
    pageChange(pageOptions) {
      this.pageIndex = pageOptions.pageIndex;
      this.pageSize = pageOptions.pageSize;
      this.getProductList();
    },
    getProductList() {
      const params = { ...this.requestParams, ...this.formData };
      reqCategory(params).then((res) => {
        this.data = res.data;
        this.categoryList = this.data;
        this.tableData = res.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}

.dialog {
  height: 85%;
}

::v-deep .van-dialog__content {
  height: 100%;

  // .van-form {
  //   height: 100%;
  // }
}

.scrollList {
  height: calc(100% - 250px) !important;

  overflow: auto;
}

::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
::v-deep .van-cell {
  padding: 2px 10px !important;
}
</style>
